import styled from 'styled-components';

export const WrapperStyled = styled.div`
  position: relative;
  min-height: 30rem;
`;
